import styled from "styled-components";
import {colorPalette} from "../styles/colorPalette";
import {ReactUtils} from "../../utils/ReactUtils";

interface ISpinnerProps {
	readonly isYellow?: boolean;
	readonly isVisible?: boolean;
}

export const Spinner = (props: ISpinnerProps) => {
	const {isYellow = false, isVisible = true} = props;

	return <SpinnerStyled className={ReactUtils.cls("SpinnerStyled", {isYellow, isVisible})} />;
};

export const SpinnerStyled = styled.span`
	visibility: hidden;
	&.isVisible {
		visibility: visible;
	}
	border-radius: 50%;
	width: 16px;
	height: 16px;

	border: 2px solid transparent;
	border-top: 2px solid ${colorPalette.primary.c500Primary};
	border-left: 2px solid ${colorPalette.primary.c500Primary};
	border-bottom: 2px solid ${colorPalette.primary.c500Primary};
	animation: spin 2s linear infinite;

	&.isYellow {
		border-top: 2px solid ${colorPalette.libraryColors.darkOrange};
		border-left: 2px solid ${colorPalette.libraryColors.darkOrange};
		border-bottom: 2px solid ${colorPalette.libraryColors.darkOrange};
	}
`;
